import { makeObservable, observable, flow, computed } from "mobx";
import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";

import AuditMaturitiesSchema from "@/areas/compliance/schemas/AuditMaturitiesSchema";
import { ComplianceConstants } from "@/areas/compliance/stores/ComplianceConstants";

export default class AuditMaturitiesStore {
  loading = true;
  pagination = null;
  maturities = [];

  constructor(parentStore) {
    makeObservable(this, {
      loading: observable,
      pagination: observable,
      maturities: observable,
      actions: computed,
      load: flow,
    });

    this.parentStore = parentStore;
  }

  get actions() {
    const list = [];

    return list;
  }

  *load(query, options) {
    const parseResult = AuditMaturitiesSchema.safeParse({
      ...query,
      id: this.parentStore.auditId,
      scopeId: this.parentStore.scope?.id,
    });

    if (!parseResult.success) {
      console.error(parseResult.error);
      return parseResult;
    }

    try {
      this.loading = true;

      const response = yield api.post(ApiRoutes.forAuditMaturitySearch(parseResult.data.id), parseResult.data);
      this.maturities = response.data.items;

      this.pagination = {
        page: response.data.page,
        totalItems: response.data.totalItems,
        totalPages: response.data.totalPages,
        pageSize: response.data.pageSize,
      };
      return { success: true, data: response.data };
    } catch (e) {
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }
}
